/* eslint-disable */

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from 'material-ui/Table';
import green from 'material-ui/colors/green';
import { CircularProgress } from 'material-ui/Progress';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Tooltip from 'material-ui/Tooltip';
import Button from 'material-ui/Button';
import AddIcon from 'material-ui-icons/Add';
import boltMapIcon2 from '../../assets/images/icon-map-bolt-cotton.png';

import { withRouter } from 'react-router';
import { lighten } from 'material-ui/styles/colorManipulator';
import { translate } from 'react-i18next';

import {
  getOrganizations,
  sortOrganizations,
  changePage,
  changeRowsPerPage,
} from '../../actions';

import { enums } from '../../enums';
import { checkUserIsAdmin } from '../../utils/user/checkAdmin/CheckAdmin';

const columnData = [
  { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
];

class OrganizationListHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      t,
      i18n,
    } = this.props;

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title={t('Sort')}
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {t(column.label)}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

OrganizationListHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});
let OrganizationListToolbar = props => {
  const { numSelected, classes, loading, t, i18n } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title">
            {t('Organizations')}
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </Typography>
        )}
      </div>
    </Toolbar>
  );
};

OrganizationListToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

OrganizationListToolbar = withStyles(toolbarStyles)(OrganizationListToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    bottom: -30,
    left: 100,
    marginTop: -12,
    marginLeft: -12,
  },
});

class OrganizationList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      order: 'asc',
      orderBy: 'id',
      selected: [],
      data: [].sort((a, b) => (a.id < b.id ? -1 : 1)),
      page: 0,
      rowsPerPage: 5,
    };
  }

  componentDidMount = () => {
    if (this.props.isAuthenticated) {
      this.props.getOrganizations();
    } else {
      this.props.history.push('/');
    }
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.props.orderBy === property && this.props.order === 'desc') {
      order = 'asc';
    }

    const organizations =
      order === 'desc'
        ? this.props.organizations.sort((a, b) =>
            b[orderBy] < a[orderBy] ? -1 : 1
          )
        : this.props.organizations.sort((a, b) =>
            a[orderBy] < b[orderBy] ? -1 : 1
          );

    this.props.sortOrganizations(organizations, order, orderBy);
  };

  handleChangePage = (event, page) => {
    this.props.changePage(page);
  };

  handleClick = (event, id) => {
    this.props.history.push('/organizations/read/' + id);
  };

  handleChangeRowsPerPage = event => {
    this.props.changeRowsPerPage(event.target.value);
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  renderCreateButton(history) {
    const { classes, user, isAuthenticated } = this.props;
    if (checkUserIsAdmin(isAuthenticated, user)) {
      return (
        <Button
          variant="fab"
          color="primary"
          aria-label="add"
          className={classes.button}
          style={{
            margin: 0,
            bottom: 'auto',
            right: 48,
            top: 85,
            left: 'auto',
            position: 'fixed',
          }}
          onClick={() => {
            this.props.history.push('/organizations/create');
          }}
        >
          <AddIcon />
        </Button>
      );
    } else return false;
  }

  render() {
    const { classes } = this.props;

    const {
      organizations,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      loading,
      t,
      i18n,
    } = this.props;

    const emptyRows =
      rowsPerPage -
      Math.min(rowsPerPage, organizations.length - page * rowsPerPage);

    return (
      <div className={classes.root}>
        <Paper className={classes.root}>
          <OrganizationListToolbar
            numSelected={selected.length}
            loading={loading}
            t={t}
            i18n={i18n}
          />
          <div>
            <Table className={classes.table} style={{ minWidth: 0 }}>
              <OrganizationListHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={organizations.length}
                t={t}
                i18n={i18n}
              />
              <TableBody>
                {organizations
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map(n => {
                    const isSelected = this.isSelected(n._id);
                    return (
                      <TableRow
                        hover
                        onClick={event => this.handleClick(event, n._id)}
                        role="checkbox"
                        aria-checked={isSelected}
                        tabIndex={-1}
                        key={n._id}
                        selected={isSelected}
                      >
                        <TableCell
                          style={{
                            cursor: 'pointer',
                          }}
                        >
                          {!n.name && (
                            <span style={{ color: 'red', fontWeight: 'bold' }}>
                              {t('Unknown organization')}
                            </span>
                          )}
                          {n.type === enums.OrganizationTypes.CUSTOMER &&
                            n.name}
                          {n.type === enums.OrganizationTypes.UTILITY && (
                            <div>
                              {n.name}
                              <img
                                src={boltMapIcon2}
                                style={{ height: 16, marginLeft: 5 }}
                              />
                            </div>
                          )}
                          {n.type === enums.OrganizationTypes.TEO && (
                            <span
                              style={{ fontWeight: 'bold', color: '#F87733' }}
                            >
                              {n.name}
                            </span>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {organizations.length === 0 ? (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={false}
                    tabIndex={-1}
                    key="no-organization"
                    selected={false}
                  >
                    <TableCell>{t('There is no organization yet')}</TableCell>
                  </TableRow>
                ) : (
                  <div />
                )}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={organizations.length}
            labelDisplayedRows={({ from, to, count }) =>
              from + '-' + to + t(' of ') + count
            }
            labelRowsPerPage={t('RowsPerPage')}
            rowsPerPageOptions={[5, 10, 25, 100]}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        {this.renderCreateButton()}
      </div>
    );
  }
}

OrganizationList.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ organizationsReducer, router, loginReducer }) => {
  const {
    currentOrganization,
    organizations,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage,
  } = organizationsReducer;
  const { location } = router;
  const { isAuthenticated, username, user } = loginReducer;
  return {
    currentOrganization,
    organizations,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage,
    location,
    isAuthenticated,
    username,
    user,
  };
};

const mapDispatchToProps = {
  getOrganizations,
  sortOrganizations,
  changePage,
  changeRowsPerPage,
};

OrganizationList = withStyles(styles, { name: 'OrganizationList' })(
  OrganizationList
);
OrganizationList = translate('translations')(OrganizationList);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OrganizationList)
);



// WEBPACK FOOTER //
// ./src/components/Organization/OrganizationList.js